import { FormBase } from "core/components";

export default class WoundOrderEditForm extends FormBase{
    constructor(hooks){
        super(hooks);
    }

    setup(){
        return {
            fields: [
                {
                    name: "facilityId",
                    label: "Facility",
                    placeholder: "Select a facility",
                    rules: "required"
                },
                {
                    name: "firstName",
                    label: "First Name",
                    placeholder: "Enter First Name",
                    rules: "required|string",
                },
                {
                    name: "lastName",
                    label: "Last Name",
                    placeholder: "Enter Last Name",
                    rules: "required|string",
                },
                {
                    name: "dateOfBirth",
                    label: "Date of Birth",
                    placeholder: "Enter Date of Birth",
                    rules: "required"
                },
                {
                    name: "dateOfService",
                    label: "Date of Service",
                    placeholder: "Enter Date of Service",
                    rules: "required"
                },
                {
                    name: "assessmentDate",
                    label: "Assessment Date",
                    placeholder: "Assessment Date",
                    rules: "required"
                }
            ],
        };
    }
}